var _rect, _polygon, _path, _path2, _path3, _path4, _circle, _path5, _polygon2, _path6, _path7, _path8, _polygon3, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _circle3, _circle4, _polygon4, _path16, _path17, _path18, _rect2, _path19, _rect3, _circle5, _circle6, _path20, _rect4, _rect5, _circle7, _circle8, _path21, _circle9, _circle10, _path22, _circle11, _circle12, _path23, _rect6, _path24, _path25, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 854.55666,
    height: 577.89722,
    viewBox: "0 0 854.55666 577.89722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.55666,
    y: 268,
    width: 110,
    height: 123,
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "95.557 576 39.557 576 33.557 528 101.557 528 95.557 576",
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.72875,702.28371,378.839,728.11866a8.22428,8.22428,0,0,0,8.69988,8.80928l13.26993-.80373a4.19488,4.19488,0,0,0,3.8153-5.2044L397.25817,701.457Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.72431,717.56077c15.6176,3.6534,26.77411,8.84633,34.103,15.87434a15.03539,15.03539,0,0,0,9.62359,4.1254c4.59653.24174,8.35492-.27349,11.17944-1.53511h.00045a4.43019,4.43019,0,0,0,2.62469-3.65076,4.50814,4.50814,0,0,0-1.88846-4.16687l-37.03954-26.3546-15.73318,6.294-3.67016,3.67016a3.63415,3.63415,0,0,0,.8002,5.74346Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M443.66188,295.74594l-105.87329-.98031c.26623-15.42064,3.85407-30.56331,11.69669-44.11378,5.15076-8.89946,5.03948-18.58474,3.7982-26.7444-1.91555-12.592,2.53886-25.47548,12.43708-33.49119a39.916,39.916,0,0,1,26.84266-8.88134l2.0558.08566a40.00777,40.00777,0,0,1,32.87054,19.76983,33.32736,33.32736,0,0,1,3.96134,20.30073c-.67106,6.60129.93466,13.26982,4.6906,20.00186C442.62144,256.47558,444.02465,275.3918,443.66188,295.74594Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M514.49653,703.22772l-20.77878,5.42055-101.1836-220.4357,6.324,215.01515H378.07935c-22.2035-101.15879-62.29053-217.90681-44.26782-254.76585l107.50757-6.324Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ff6600"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 218.90906,
    cy: 69.68505,
    r: 28.00618,
    fill: "#ffb9b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.0232,282.23167l-46.07467-2.71028c4.51541-10.36377,6.31912-20.34363,4.51712-29.813H408.7958C408.718,256.979,412.33611,269.55581,416.0232,282.23167Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ffb9b9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.211 289.217 171.028 296.445 181.417 117.115 199.034 112.146 218.909 116.663 238.784 106.725 251.432 111.243 272.211 289.217",
    fill: "#ff6600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.91428,579.45849l-69.112-15.80994c20.5506-68.14818,57.57349-224.05122,45.623-279.61l36.137-16.26165Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.48755,382.51184l-26.19932-16.26165,22.3434-65.4394a30.87113,30.87113,0,0,1,13.49426-16.02839l7.52674-4.35758-4.51713,65.95Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M505.01057,564.552c-21.81327,12.62013-76.33909,19.65509-100.28018,10.8411-1.76169-61.57277-5.21664-235.739,5.87226-309.42306l39.7507,16.26165-3.6137,48.78495C427.73558,372.74951,482.91928,518.10538,505.01057,564.552Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.127 213.33 304.734 205.199 272.211 168.158 277.632 121.18 331.837 197.068 329.127 213.33",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.40285,409.54533a6.78537,6.78537,0,0,0,8.10524,5.11221l20.706-4.68917-2.99259-13.21656-20.70643,4.68828a6.77693,6.77693,0,0,0-5.11221,8.10524Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ffb9b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M416.0232,223.509c-15.55574-6.3965-30.9192-6.85936-46.07467-.90342l-6.324-22.58563h57.8192Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M444.02938,394.25637l11.74452,21.6822c19.7541-5.50955,36.87412-22.87878,53.30208-43.3644l-4.51713-14.4548-28.00617,7.2274Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M435.44684,349.53683h-3.6137c0-51.11057-10.52349-86.7288-20.77877-86.7288l-.90343-3.6137c9.197,0,15.06047,14.824,18.35964,27.26023C432.9836,303.31394,435.44684,325.71693,435.44684,349.53683Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M352.33174,336.88888H348.718c0-46.80915,10.59628-75.8877,26.19933-75.8877l-.90343,3.6137C363.22136,264.61488,352.33174,286.96274,352.33174,336.88888Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.91832,
    cy: 189.38886,
    r: 9.03425,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.87694,358.57108h-3.6137c0-12.95189,7.29489-23.48905,16.26165-23.48905v3.6137C343.5507,338.69573,337.87694,347.61176,337.87694,358.57108Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M366.78654,358.57108h-3.6137c0-10.95932-5.67376-19.87535-12.64795-19.87535V335.082C359.49165,335.082,366.78654,345.61919,366.78654,358.57108Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.25802,
    cy: 198.42311,
    r: 3.6137,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.34842,
    cy: 198.42311,
    r: 3.6137,
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.177 165.193 140.724 169.219 192.258 242.495 164.88 236.053 118.177 165.193",
    fill: "#ff6600"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.8996,325.34727a1.91768,1.91768,0,0,0-1.5735,2.971l48.17135,73.08788a1.91143,1.91143,0,0,0,1.16016.81035l22.4127,5.27321a1.91439,1.91439,0,0,0,2.00447-2.9648L306.1856,329.32314a1.90335,1.90335,0,0,0-1.22941-.783l-17.69531-3.16023A2.07607,2.07607,0,0,0,286.8996,325.34727Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M316.94907,377.60432l1.33881,13.48521,21.12638-2.09711a6.77573,6.77573,0,0,0-1.33837-13.48521Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298.57839,376.04229a17.42694,17.42694,0,0,0,17.40637,17.31065h3.47387l2.529-21.07565-20.93979-7.53839Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 442.55666,
    width: 412,
    height: 217,
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M627.27833,366.05139h388v-193h-388Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 484.55666,
    y: 40,
    width: 138,
    height: 138,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 589.55666,
    cy: 99,
    r: 4,
    fill: "#ff6600"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.55666,
    cy: 85,
    r: 4,
    fill: "#ff6600"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M745.27833,260.05139a7.95011,7.95011,0,0,0-4.16785,1.181,25.12434,25.12434,0,0,0-3.86474-4.53583c.01708-.21344.03259-.42731.03259-.64514a7.99417,7.99417,0,0,0-13.54682-5.7569,24.50673,24.50673,0,0,0-6.46264-.05639c.00146-.06269.00946-.12366.00946-.18671a8,8,0,1,0-13.2594,6.01813,25.14047,25.14047,0,0,0-3.62439,3.83362,7.99939,7.99939,0,1,0-5.11621,14.14825l.02533-.00128c-.01313.33258-.02533.66546-.02533,1.00128a25.045,25.045,0,0,0,.72363,5.973,14.99382,14.99382,0,1,0,19.56885,18.57819,24.97131,24.97131,0,0,0,16.34241-2.42426,8.00091,8.00091,0,1,0,10.492-10.492,24.85715,24.85715,0,0,0,2.84784-10.63617l.02527.00128a8,8,0,0,0,0-16Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ff6600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 530.55666,
    y: 37,
    width: 40,
    height: 6,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 660.55666,
    y: 40,
    width: 138,
    height: 138,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.75666,
    cy: 131.8,
    r: 1.8,
    fill: "#ff6600"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.00666,
    cy: 125.5,
    r: 1.8,
    fill: "#ff6600"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M920.82833,292.85139a3.57749,3.57749,0,0,0-1.87553.53144,11.30621,11.30621,0,0,0-1.73914-2.04113c.00769-.096.01467-.19228.01467-.29031a3.59737,3.59737,0,0,0-6.09607-2.5906,11.02775,11.02775,0,0,0-2.90819-.02538c.00066-.02821.00426-.05565.00426-.084a3.6,3.6,0,1,0-5.96673,2.70816,11.31327,11.31327,0,0,0-1.631,1.72513,3.59972,3.59972,0,1,0-2.30229,6.36671l.0114-.00058c-.00591.14966-.0114.29946-.0114.45058a11.27051,11.27051,0,0,0,.32563,2.68783,6.74722,6.74722,0,1,0,8.806,8.36019,11.23714,11.23714,0,0,0,7.35409-1.09092,3.60041,3.60041,0,1,0,4.7214-4.7214,11.18577,11.18577,0,0,0,1.28153-4.78628l.01137.00058a3.6,3.6,0,0,0,0-7.2Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ff6600"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 769.87848,
    cy: 97.64171,
    r: 1.8,
    fill: "#ff6600"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.11285,
    cy: 89.43667,
    r: 1.8,
    fill: "#ff6600"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M940.52643,251.32953a3.57751,3.57751,0,0,0-1.01994-1.66125,11.3064,11.3064,0,0,0,1.49326-2.22732c.09454-.01863.18907-.038.28342-.06458a3.59737,3.59737,0,0,0,.84112-6.57006,11.02787,11.02787,0,0,0-.76391-2.80619c.02733-.007.05472-.011.082-.01867a3.6,3.6,0,1,0-4.22419-5.00922,11.3133,11.3133,0,0,0-2.10265-1.10227,3.59973,3.59973,0,1,0-6.75243-.49024l.00365.01082c-.14566.03488-.29134.0702-.4368.11117a11.27,11.27,0,0,0-2.49892,1.042,6.74722,6.74722,0,1,0-5.66009,10.74251,11.2371,11.2371,0,0,0,3.04357,6.783,3.60041,3.60041,0,1,0,5.82448,3.26477,11.1857,11.1857,0,0,0,4.95446-.06389l.00252.0111a3.6,3.6,0,1,0,6.93042-1.95173Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ff6600"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.16182,
    cy: 73.18149,
    r: 1.8,
    fill: "#ff6600"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.95808,
    cy: 73.91887,
    r: 1.8,
    fill: "#ff6600"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M867.72564,239.88258a3.57754,3.57754,0,0,0-.87207,1.74343,11.306,11.306,0,0,0-2.68-.0918c-.06574-.07044-.13212-.14048-.20451-.20657a3.59737,3.59737,0,0,0-6.02337,2.75542,11.02762,11.02762,0,0,0-1.97953,2.13065c-.02039-.01951-.03822-.04067-.05918-.05979a3.6,3.6,0,1,0-2.02291,6.23247,11.31355,11.31355,0,0,0,.17439,2.36765,3.59972,3.59972,0,1,0,3.14968,5.99292l.00726-.00881c.10655.10527.21348.21033.32508.31221a11.26967,11.26967,0,0,0,2.20457,1.57173,6.74722,6.74722,0,1,0,12.11144-.86672,11.23714,11.23714,0,0,0,4.15267-6.16668,3.60041,3.60041,0,1,0-.30355-6.67017,11.18565,11.18565,0,0,0-2.67072-4.17348l.00809-.008a3.6,3.6,0,1,0-5.31735-4.85445Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#ff6600"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 706.55666,
    y: 37,
    width: 40,
    height: 6,
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M197.89809,671.2944c14.41965,19.311,44.352,21.34353,44.352,21.34353s6.55352-29.27679-7.86613-48.5878-44.352-21.34353-44.352-21.34353S183.47844,651.98339,197.89809,671.2944Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M271.35481,678.554c-9.51509,12.74275-29.26658,14.08395-29.26658,14.08395s-4.32447-19.31887,5.19063-32.06162,29.26658-14.084,29.26658-14.084S280.86991,665.81122,271.35481,678.554Z",
    transform: "translate(-172.72167 -161.05139)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 575.6565,
    width: 519.55666,
    height: 2.24072,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.bd4e23f588276cf6143aefa27633ae9c.svg";
export { ForwardRef as ReactComponent };